import { render, staticRenderFns } from "./MerchantDiscounts.vue?vue&type=template&id=3600889c&scoped=true"
import script from "./MerchantDiscounts.vue?vue&type=script&lang=js"
export * from "./MerchantDiscounts.vue?vue&type=script&lang=js"
import style0 from "./MerchantDiscounts.vue?vue&type=style&index=0&id=3600889c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3600889c",
  null
  
)

export default component.exports